import Vue from 'vue';
import Vuex from 'vuex';
import { RootState } from '@/interface/store';
import { auth } from './modules/auth';
import { manageGroup } from './modules/manageGroup';
import { profile } from './modules/profile';
import { inventory } from './modules/inventory';
import { request } from './modules/request';
import { purchaseOrder } from './modules/purchaseOrder';

import * as API from '@/api/export';

Vue.use(Vuex);

const store: any = new Vuex.Store<RootState>({
  state: {
    isLoading: false,
    isLogin: false,
    property: {
      email: '',
    },
    lastGroupId: null,
    isMobileFilterPageUp: false,
    isMobileFilterOn: false,
  },
  mutations: {
    IS_LOADING(state, bool: boolean) {
      state.isLoading = bool;
    },
    SET_LAST_GROUP_ID(state, id: string) {
      state.lastGroupId = id;
    },
    RESET_ALL(state) {
      state.isLoading = false;
      state.isLogin = false;
      state.property = {
        email: '',
      };
      state.lastGroupId = null;
    },
    IS_MOBILE_FILTER_PAGE_UP(state, bool: boolean) {
      state.isMobileFilterPageUp = bool;
    },
    IS_MOBILE_FILTER_ON(state, bool: boolean) {
      state.isMobileFilterOn = bool;
    },
  },
  getters: {
    getterIsLoading: (state) => state.isLoading,
    getterLastGroupId: (state) => state.lastGroupId,
    getterIsMobileFilterPageUp: (state) => state.isMobileFilterPageUp,
    getterIsMobileFilterOn: (state) => state.isMobileFilterOn,
  },
  actions: {
    async getExport({ commit }, { exportId }: { exportId: string }) {
      try {
        const { data } = await API.getExport(exportId);
        return data;
      } catch (e) {
        throw e;
      }
    },
    async getImport({ commit }, { importId }: { importId: string }) {
      try {
        const { data } = await API.getImport(importId);
        return data;
      } catch (e) {
        throw e;
      }
    },
  },
  modules: {
    auth,
    manageGroup,
    profile,
    inventory,
    request,
    purchaseOrder,
  },
});

export default store;
